(function(){
  var PRO=!!window.PT_PRO,R=PRO?30000:5900,D=PRO?50000:9900,fmt=window.PT_MONEY||'€{{amount_with_comma_separator}}';
  var RT=[[150,420],[400,480],[900,540],[1900,650],[2900,765],[4900,1170],[6900,1340],[9900,1515],[14900,2205],[19900,2550],[24900,3030],[29900,3630]];
  var DT=[[500,854],[750,865],[1000,940],[2000,1170],[5000,1600],[10000,2420],[30000,3000],[1e9,5000]];
  var pubCache={};
  function money(c){return fmt.replace(/\{\{\s*\w+\s*\}\}/,(c/100).toFixed(2).replace('.',','))}
  function esc(s){var d=document.createElement('div');d.textContent=s;return d.innerHTML}
  function rate(T,w){for(var i=0;i<T.length;i++)if(w<=T[i][0])return T[i][1];return 0}
  function hosts(){
    var t=document.querySelector('cart-items .title-wrapper-with-link');
    if(t&&!document.getElementById('pt-ship-cart')){var d=document.createElement('div');d.id='pt-ship-cart';d.setAttribute('data-pt-ship','');t.parentNode.insertBefore(d,t.nextSibling)}
    return document.querySelectorAll('[data-pt-ship]');
  }
  function applyCode(code){return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:code})}).then(function(r){return r.json()})}
  function proSaving(cart){
    if(!PRO)return Promise.resolve(0);
    return Promise.all(cart.items.map(function(i){
      if(i.handle.indexOf('b2b-')!==0)return 0;
      var h=i.handle.slice(4);
      pubCache[h]=pubCache[h]||fetch('/products/'+h+'.js').then(function(r){return r.ok?r.json():null}).catch(function(){return null});
      return pubCache[h].then(function(p){if(!p)return 0;var ref=Math.round(p.price*1.25);return Math.max(0,ref-i.original_price)*i.quantity});
    })).then(function(a){return a.reduce(function(s,x){return s+x},0)});
  }
  function summary(cart){
    var first=document.querySelector('#main-cart-footer .cart__blocks .js-contents');
    if(!first)return;
    var el=document.getElementById('pt-sum');
    if(!el){el=document.createElement('div');el.id='pt-sum';first.parentNode.insertBefore(el,first)}
    var codes=(cart.discount_codes||[]),ok=codes.filter(function(c){return c.applicable}),bad=codes.filter(function(c){return !c.applicable});
    var okNames=ok.map(function(c){return c.code.toLowerCase()});
    var map={};
    cart.items.forEach(function(i){(i.line_level_discount_allocations||[]).forEach(function(a){var t=(a.discount_application&&a.discount_application.title)||'Réduction';map[t]=(map[t]||0)+a.amount})});
    (cart.cart_level_discount_applications||[]).forEach(function(a){map[a.title]=(map[a.title]||0)+a.total_allocated_amount});
    proSaving(cart).then(function(pro){
      var rows='',tot=0;
      function row(label,amount){tot+=amount;rows+='<div class="pt-sum__row"><span>'+label+'</span><b>-'+money(amount)+'</b></div>'}
      if(pro)row('Remise pro sur le prix public',pro);
      Object.keys(map).forEach(function(t){
        if(okNames.indexOf(t.toLowerCase())>-1)row('Code '+esc(t)+' <button type="button" class="pt-sum__rm" id="pt-rm">Retirer</button>',map[t]);
        else row(esc(t),map[t]);
      });
      if(cart.total_price>=R){
        var ship=cart.total_price>=D?rate(DT,cart.total_weight):rate(RT,cart.total_weight);
        if(ship)row(cart.total_price>=D?'Livraison offerte':'Point relais offert',ship);
      }
      var promo=(PRO||ok.length)?'':'<form class="pt-promo" id="pt-promo"><input id="pt-code" placeholder="Code promo" autocomplete="off" aria-label="Code promo"><button type="submit">Appliquer</button></form>'+(bad.length?'<p class="pt-promo__msg">Le code '+esc(bad[0].code)+' n’est pas valable pour ce panier.</p>':'');
      var ht=PRO?'<div class="pt-sum__row"><span>Total HT</span><b style="color:#fff">'+money(Math.round(cart.total_price/1.2))+'</b></div><div class="pt-sum__row"><span>TVA 20 %</span><span>'+money(cart.total_price-Math.round(cart.total_price/1.2))+'</span></div>':'';
      el.innerHTML=promo+((rows||ht)?'<div class="pt-sum">'+rows+(tot?'<div class="pt-sum__row pt-sum__total"><span>'+(PRO?'Votre avantage pro':'Vous économisez')+'</span><span>'+money(tot)+'</span></div>':'')+ht+'</div>':'');
      var f=document.getElementById('pt-promo');if(f)f.addEventListener('submit',function(e){e.preventDefault();var c=document.getElementById('pt-code').value.trim();if(c)applyCode(c).then(function(){location.reload()})});
      var rm=document.getElementById('pt-rm');if(rm)rm.addEventListener('click',function(){applyCode('').then(function(){location.reload()})});
    });
  }
  function draw(cart){
    summary(cart);
    var total=cart.total_price,msg,lr=PRO?'300 €':'59 €',ld=PRO?'500 €':'99 €';
    if(total>=D)msg='<b>Bravo !</b> Votre livraison est offerte, en point relais comme à domicile.';
    else if(total>=R)msg='<b>Point relais offert !</b> Plus que <b>'+money(D-total)+'</b> pour la livraison à domicile offerte.';
    else msg='Plus que <b>'+money(R-total)+'</b> pour le point relais offert.';
    var pct=Math.min(100,total/D*100),m=R/D*100;
    var html='<div class="pt-ship"><p class="pt-ship__msg">'+msg+'</p><div class="pt-ship__bar"><div class="pt-ship__fill'+(total>=D?' done':'')+'" style="width:'+pct+'%"></div><i class="pt-ship__mark" style="left:'+m+'%"></i></div><div class="pt-ship__labels"><span style="left:'+m+'%">Relais '+lr+'</span><span style="left:100%">Domicile '+ld+'</span></div></div>';
    hosts().forEach(function(h){h.innerHTML=cart.item_count?html:''});
  }
  function refresh(){fetch('/cart.js?t='+Date.now(),{headers:{Accept:'application/json'},cache:'no-store'}).then(function(r){return r.json()}).then(draw).catch(function(){})}
  function hover(){
    document.head.insertAdjacentHTML('beforeend','<style>.pt-hover{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity .25s;z-index:2;pointer-events:none}.pt-touch .pt-hover.on{opacity:1}.pt-upsell__media{position:relative}@media(hover:hover){.card-wrapper:hover .pt-hover.on,.pt-upsell__card:hover .pt-hover.on{opacity:1}}#main-cart-footer .discounts{display:none}#pt-sum .pt-sum{margin:0 0 1.4rem;padding:0 0 1.2rem;border-top:0;border-bottom:1px solid rgba(233,238,245,.14)}#pt-sum .pt-promo{margin:0 0 1.4rem}#pt-sum .pt-sum__row{align-items:baseline;font-size:1.4rem}#pt-sum .pt-sum__total{margin-top:.9rem;padding-top:.9rem;border-top:1px dashed rgba(53,214,255,.35);font-size:1.5rem}</style>');
    var cache={},sel='.card-wrapper,.pt-upsell__card';
    function load(w){
      if(!w||w.dataset.ptHover)return;
      w.dataset.ptHover='1';
      var a=w.querySelector('a[href*="/products/"]'),box=w.querySelector('.card__media .media,.pt-upsell__media');
      if(!a||!box)return;
      var h=a.getAttribute('href').split('/products/')[1].split(/[?#]/)[0];
      cache[h]=cache[h]||fetch('/products/'+h+'.js').then(function(r){return r.json()});
      cache[h].then(function(p){
        var ms=(p.media||[]).filter(function(m){return m.media_type==='image'});
        var pick=ms.filter(function(m){return /avec/i.test(m.alt||'')})[0]||ms[1];
        if(!pick)return;
        var i=new Image();i.className='pt-hover';i.alt=pick.alt||p.title;i.onload=function(){box.appendChild(i);requestAnimationFrame(function(){i.classList.add('on')})};
        i.src=pick.src+(pick.src.indexOf('?')>-1?'&':'?')+'width=600';
      }).catch(function(){});
    }
    if(window.matchMedia('(hover:hover)').matches){
      document.addEventListener('mouseover',function(e){load(e.target.closest&&e.target.closest(sel))});
      return;
    }
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){io.unobserve(e.target);load(e.target)}})},{rootMargin:'300px'});
      document.querySelectorAll(sel).forEach(function(w){io.observe(w)});
    }
    var timer;
    function clear(){document.querySelectorAll('.pt-touch').forEach(function(w){w.classList.remove('pt-touch')})}
    document.addEventListener('touchstart',function(e){
      clearTimeout(timer);clear();
      var w=e.target.closest&&e.target.closest(sel);
      if(!w)return;
      load(w);w.classList.add('pt-touch');
    },{passive:true});
    function end(){clearTimeout(timer);timer=setTimeout(clear,700)}
    document.addEventListener('touchend',end,{passive:true});
    document.addEventListener('touchcancel',end,{passive:true});
  }
  document.addEventListener('DOMContentLoaded',function(){
    var c=document.querySelector('.footer__content-top'),n=c&&c.querySelector('.footer-block--newsletter');
    if(n)c.insertBefore(n,c.firstChild);
    hover();refresh();
    if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,refresh);
    var t=document.getElementById('main-cart-footer');
    if(t)new MutationObserver(function(){refresh()}).observe(t.querySelector('.js-contents')||t,{childList:true,subtree:true,characterData:true});
  });
  window.addEventListener('pageshow',function(e){if(e.persisted)refresh()});
})();
